<span class="_content">
    <ng-content />
</span>
@if (icon || buttonStyle ==='text-button') {
<i class="_icon"
   lineHeightBy="_content"
   [class]="buttonStyle === 'text-button' ? 'icon-arrow-right' : 'icon-' + icon"></i>
}
@if (isBusy) {
<div class="_loader">
    <loader-1 class="block" />
</div>
}